import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OrderStatus } from 'src/app/data/constants/orderStatus.enum';
import { ModalService } from 'src/app/services/modal.service';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';
import { BaseAdapter } from 'src/whiteLabel/mediaCorps/adapters/base-adapter';
import { api } from 'src/whiteLabel/mediaCorps/services/misc/misc-api.service';
import { BusinessProfile, TermsAndConditionsData } from 'src/whiteLabel/mediaCorps/services/misc/misc-data';

@Injectable({
    providedIn: 'root'
})
export class MiscAdapter extends BaseAdapter {

    constructor(
        protected http: HttpClient,
        protected localStore: StorageService,
        protected modal: ModalService) {
        super(http, localStore, modal);
    }

    public getPromotion(): Promise<{ message: string; valid_to: Date }> {
        return api.getPromotion(this.http, environment.platformClientId).then((resp) => {
            return {
                message: resp.message,
                valid_to: resp.valid_to && resp.valid_to.length > 0 ? new Date(resp.valid_to) : null
            }
        });
    }

    public getTermsAndConditionsData(is_accepted: boolean): Promise<TermsAndConditionsData> {
        return api.getTermsAndConditionsData(this.http, is_accepted).then((rows) => {
            const terms = new TermsAndConditionsData();
            terms.data = rows;
            terms.count = rows && rows.length ? rows.length : 0;
            return terms;
        });
    }

    public getTermsAndConditionsFile(download_url: string): Promise<ArrayBuffer> {
        return api.getTermsAndConditionsFile(this.http, download_url);
    }

    public acceptTermsAndConditions(termsVersionId: number) {
        return api.acceptTermsAndConditions(this.http, termsVersionId);
    }

    public sendForgotPasswordEmail(email: string): Promise<any> {
        return api.sendForgotPasswordEmail(this.http, email);
    }

    public getUserDetails(): Promise<Array<any>> {
        return this.getCustomers()
            .then((customers: any[]) => {
                let allPromise = [];
                if (customers) {
                    customers.forEach(customer => {
                        allPromise.push(api.getUserDetails(this.http, customer.Id.toString()));
                    });
                }
                return Promise.all(allPromise);
            });
    }

    public isCreditAccountNumberApproved(customerId: string): Promise<boolean> {
        return api.getUserDetails(this.http, customerId).then((data) => {
            //    return api.isCreditAccountNumberApproved(this.http, '' + environment.sellerId, data.business_profile.business_profile_id.toString()).then((resp: BusinessProfile) => resp.is_credit_account_number_approved);
            return data.business_profile ? data.business_profile.is_credit_account_number_approved || false : false;
        });
    }

    public patchPaymentStatus(orderId: string, status: OrderStatus): Promise<any> {
        return api.patchPaymentStatus(this.http, orderId, status);
    }

}
